import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SeraTableCol } from '../sera-table/models/SeraTableCol';
import { globalVar } from '../../global_variables';
import { Table } from 'primeng/table';
import { ImageItem } from '../sera-image/models/image-item';

@Component({
    selector: 'header-data-table',
    templateUrl: './header-data-table.component.html',
    styleUrl: './header-data-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderDataTableComponent {
    protected readonly globalVar = globalVar;

    @ViewChild('table') table!: Table;

    @Input() cols: SeraTableCol[] = [];

    @Input() data: any[] = [];

    @Input() isEditMode: boolean = false;

    @Input() scrollable: boolean = false;

    @Input()
    emptyStateImage: ImageItem = { id: 1, src: 'assets/images/MM13/empty_table.png', alt: 'Empty State', height: 64, disableInteractions: true };

    @Input()
    emptyStateMessage: string = 'GENERAL.NO_RESULTS.LBL';

    @Output() cellValueChanged = new EventEmitter<{ rowData: any; field: string; value: any }>();
    protected Math = Math;

    onCellValueChange(rowData: any, field: string, value: any): void {
        this.cellValueChanged.emit({ rowData, field, value });
    }
}
